module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('tr', [_vm._c('td', {
    staticClass: "hidden-xs"
  }), _vm._v(" "), _vm._c('td', {
    staticClass: "cell-detail",
    class: {
      editingTitle: _vm.editingTitle
    }
  }, [(_vm.editingTitle) ? _vm._c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.finishEditingTitle($event)
      }
    }
  }, [_vm._c('div', {
    staticClass: "input-group input-group-sm"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTitle),
      expression: "newTitle"
    }, {
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "on-click-away",
      rawName: "v-on-click-away",
      value: (_vm.cancelEditingTitle),
      expression: "cancelEditingTitle"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newTitle)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.cancelEditingTitle($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]) : _vm._c('div', [_vm._c('span', {
    on: {
      "dblclick": _vm.startEditingTitle
    }
  }, [_vm._v("\n        " + _vm._s(_vm.chapter.title) + "\n        ")]), _vm._v(" "), _vm._c('span', {
    staticClass: "cell-detail-description"
  }, [_vm._v("\n        " + _vm._s(_vm.activeMicroNoteCount || 0) + "\n        Micro Note" + _vm._s((_vm.activeMicroNoteCount || 0) === 1 ? '' : 's') + "\n      ")])])]), _vm._v(" "), (_vm.studyProgressPercent === 100) ? _vm._c('td', {
    staticClass: "milestone"
  }, [_vm._c('span', {
    staticClass: "completed"
  }, [_vm._v(_vm._s(_vm.studyProgressPercent) + "%")]), _vm._v(" "), _vm._c('span', {
    staticClass: "version"
  }, [_vm._v("Complete!")]), _vm._v(" "), _vm._c('div', {
    staticClass: "progress"
  }, [_vm._c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: ('width: ' + _vm.studyProgressPercent + '%')
  })])]) : _vm._c('td', {
    staticClass: "milestone"
  }, [_vm._c('span', {
    staticClass: "completed"
  }, [_vm._v(_vm._s(_vm.studyProgressPercent) + "%")]), _vm._v(" "), _vm._c('span', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.unstudiedMicroNotesCount) + " remaining")]), _vm._v(" "), _vm._c('div', {
    staticClass: "progress"
  }, [_vm._c('div', {
    staticClass: "progress-bar progress-bar-primary",
    style: ('width: ' + _vm.studyProgressPercent + '%')
  })])]), _vm._v(" "), _vm._c('td', {
    staticClass: "hidden-xs"
  }), _vm._v(" "), _vm._c('td', {
    staticClass: "cell-detail hidden-xs"
  }, [_vm._c('small', [_vm._v(_vm._s(_vm.friendlyLastStudiedAt))])]), _vm._v(" "), _vm._c('td', {
    staticClass: "text-right"
  }, [_vm._c('div', {
    staticClass: "btn-group btn-hspace"
  }, [(_vm.chapter.micro_notes_count && _vm.studyProgressPercent < 100) ? _vm._c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'chapter-studier',
        params: {
          chapterId: _vm.chapter.id
        }
      }
    }
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-play-circle-outline"
  }), _vm._v(" Study")]) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _vm._c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Actions "), _vm._c('span', {
    staticClass: "icon-dropdown mdi mdi-chevron-down"
  })]) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _vm._c('ul', {
    staticClass: "dropdown-menu pull-right",
    attrs: {
      "role": "menu"
    }
  }, [(_vm.chapter.micro_notes_count) ? _vm._c('li', [_vm._c('router-link', {
    staticClass: "tooltip-custom",
    attrs: {
      "to": {
        name: 'micro-note-editor',
        params: {
          chapterId: _vm.chapter.id
        }
      }
    }
  }, [_vm._v("\n          Edit Micro Notes\n           "), _vm._c('div', {
    staticClass: "popup"
  }, [_vm._v("\n              Edit existing micronotes\n           ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "carret"
  })])], 1) : _vm._e(), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
    staticClass: "tooltip-custom",
    attrs: {
      "to": {
        name: 'micro-note-creator',
        params: {
          chapterId: _vm.chapter.id
        }
      }
    }
  }, [_vm._v("\n          Create Micro Notes\n          "), _vm._c('div', {
    staticClass: "popup"
  }, [_vm._v("Create additional micro notes"), _vm._c('br'), _vm._v("from imported lecture note")]), _vm._v(" "), _vm._c('div', {
    staticClass: "carret"
  })])], 1), _vm._v(" "), _vm._c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'share-chapter',
        params: {
          chapterId: _vm.chapter.id
        }
      }
    }
  }, [_vm._v("Share")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportChapter(_vm.chapter)
      }
    }
  }, [_vm._v("Export")])]), _vm._v(" "), _vm._c('li', [_vm._c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteChapter(_vm.chapter)
      }
    }
  }, [_vm._v("Delete")])])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('span', {
    staticClass: "input-group-btn"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-313d8c6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subject-shelf/SubjectShelfChapterRow.vue
// module id = 645
// module chunks = 1